import React, { useState, useEffect, useMemo } from "react";

import { useFormik } from "formik";
import { Button, Card, CardContent, ButtonGroup, Checkbox } from "@material-ui/core";
import {
    FormGroup,
    useStyles,
    ButtonWrapper,
    Splitter,
} from "../../../../styles/common-styles";
import HeaderTitle from "../../../../utils/HeaderTitle/HeaderTitle";
import ElementsDataGridPro from "../../../../utils/DataGrid/ElementsDataGridPro";
import { useTranslation } from "react-i18next";
import { SelectInput } from "../../../../components/Forms";
import AddISIRSAIDetails from "./addIsirSAIDetails";
import AddCustomISRRecord from "./addCustomIsrRecord";
import UpdateISIRCommentCodesdetails from "./UpdateISIRCommentCodesdetails";
import { useSelector } from 'react-redux';
import { deleteApi, getApi, postApi } from "../../../../services/apiBase";
import { formatTime } from "../../../../helper/formatTime";
import { isir_financial, isir_financial_grid_new, isir_financial_grid_2_3, isir_select_items, isir_set_comment_resolved, ISIR_set_Active, ISIR_Toggle_Lock } from "../../../../services/apiURL";
import GenericModal from "../../../../components/Modal/GenericModal";
import { toastMessage } from "../../../../utils/Message/toasts";
import ShowISIRReport from "./ShowISIRReport";
import { updateAccessSelector } from "../../../../redux/common/roleAccess/selectors";
import { maintenance } from "../../../../helper/constants";
import { Label } from "@material-ui/icons";

const Isir = ({ getSelectedRow, selectedStatusRow, addDatas, fyDropDown, selectedSelected }) => {

    const initialValues = {
        filtertoPackage: selectedStatusRow?.financialStatusID
    };

    const [tableRow, setTableRow] = useState([]);
    const [tableRow2, setTableRow2] = useState([]);
    const [showISIRFullReport, setShowISIRFullReport] = useState(false);
    const [resetGrid, setResetGrid] = useState(0);
    const [resetGrid2, setResetGrid2] = useState(0);
    const [selectedCommentRows, setSelectedCommentRows] = useState([]);

    const [selectedRow1, setSelectedRow1] = useState('');
    const [fullReportSelectedRow, setFullReportSelectedRow] = useState('');
    const [dropdown, setDropdown] = useState({
        "applicationTypeList": [],
        "housingStatusList": [],
        "fieldNamesList": [],
        "pellLifeTimeList": [],
        "dependentStatusList": [],
        "enrollmentStatusList": [],
        "interestedInLoansList": [],
        "finISARRecordsList": [],
        "customImportFieldsList": [],
        "filterToPackageList": []
    });

    const { t } = useTranslation(['translation', 'financialAid', 'financialAidHeadcells', `registrationHeadCells`]);
    const [showAddIsirdetails, setShowAddIsirdetails] = useState(false);
    const [showAddCustomIsirdetails, setShowCustomAddIsirdetails] = useState(false);
    const [showUpdateISIRCommentCodesdetails, setShowUpdateISIRCommentCodesdetails] = useState(false);
        
    const [showPopup, setShowPopup] = useState(false)
    const [popup, setPopup] = useState(false)
    const [msg, setMsg] = useState('')

    const financialISIR = useMemo(() => [
        { id: 'yearIndicator', numeric: true, disablePadding: false, label: t('financialISIR.yearIndicator', { ns: 'financialAidHeadcells' }) },
        { id: 'transactionID', numeric: true, disablePadding: false, label: t('financialISIR.transactionID', { ns: 'financialAidHeadcells' }) },
        { id: 'insertUserId', numeric: true, disablePadding: false, label: t('financialISIR.insertUserID', { ns: 'financialAidHeadcells' }) },
        { id: 'insertTime', numeric: true, disablePadding: false, label: t('financialISIR.insertTime', { ns: 'financialAidHeadcells' }),
            renderCell: (params) => (params.value ? formatTime(params.value) : '')
         },
        {
            id: 'activeFlag', numeric: true, disablePadding: false, label: t('financialISIR.activeFlag', { ns: 'financialAidHeadcells' }),
            renderCell: (params) => <Checkbox checked={params.row.activeFlag === true || params.row.activeFlag === 'Y'} disabled disableRipple style={{ color: "rgba(0, 0, 0, 0.26)", padding: 0, backgroundColor: 'transparent' }} />
        },
        {
            id: 'lock', numeric: true, disablePadding: false, label: t('financialISIR.lock', { ns: 'financialAidHeadcells' }),
            renderCell: (params) => <Checkbox checked={params.row.lock === true || params.row.lock === 'Y'} disabled disableRipple style={{ color: "rgba(0, 0, 0, 0.26)", padding: 0, backgroundColor: 'transparent' }} />
        },
        { id: 'studentUID', numeric: true, disablePadding: false, label: t('financialISIR.studentUID', { ns: 'financialAidHeadcells' }) },
        { id: 'studentSSN', numeric: true, disablePadding: false, label: t('financialISIR.studentSSN', { ns: 'financialAidHeadcells' }) },
        { id: 'studentLast', numeric: true, disablePadding: false, label: t('financialISIR.studentLast', { ns: 'financialAidHeadcells' }) },
        { id: 'studentFirst', numeric: true, disablePadding: false, label: t('financialISIR.studentFirst', { ns: 'financialAidHeadcells' }) },
        { id: 'studentMiddle', numeric: true, disablePadding: false, label: t('financialISIR.studentMiddle', { ns: 'financialAidHeadcells' }) },
        { id: 'address', numeric: true, disablePadding: false, label: t('financialISIR.address', { ns: 'financialAidHeadcells' }) },
        { id: 'city', numeric: true, disablePadding: false, label: t('financialISIR.city', { ns: 'financialAidHeadcells' }) },
        { id: 'state', numeric: true, disablePadding: false, label: t('financialISIR.state', { ns: 'financialAidHeadcells' }) },
        { id: 'zipCode', numeric: true, disablePadding: false, label: t('financialISIR.zipCode', { ns: 'financialAidHeadcells' }) },
        { id: 'country', numeric: true, disablePadding: false, label: t('financialISIR.country', { ns: 'financialAidHeadcells' }) },
        { id: 'phone', numeric: true, disablePadding: false, label: t('financialISIR.phone', { ns: 'financialAidHeadcells' }) },
        { id: 'email', numeric: true, disablePadding: false, label: t('financialISIR.email', { ns: 'financialAidHeadcells' }) },
        { id: 'pellEligibilityFlag', numeric: false, disablePadding: false, label: t('financialISIR.pellEligibilityFlag', { ns: 'financialAidHeadcells' }) },
        { id: 'financialISIRID', numeric: true, disablePadding: false, label: t('financialISIR.financialISIRID', { ns: 'financialAidHeadcells' }) },
        { id: 'financialStatusUID', numeric: true, disablePadding: false, label: t('financialISIR.financialStatusUID', { ns: 'financialAidHeadcells' }) },
        { id: 'documentID', numeric: true, disablePadding: false, label: t('financialISIR.documentID', { ns: 'financialAidHeadcells' }) }
      
    ], [t])

    const commentcodesforISR = useMemo(() => [
        { id: 'commentCode', numeric: true, disablePadding: false, label: t('commentcodesforISR.commentCode', { ns: 'financialAidHeadcells' }) },
        { 
            id: 'comment', numeric: true, disablePadding: false, label: t('commentcodesforISR.comment', { ns: 'financialAidHeadcells' }),
            renderCell: (params) => (
                <div onClick={() => {
                    setMsg(params.value);
                    setPopup(true);
                }} style={{ cursor: 'pointer', width: '100%', height: '100%', display: 'flex', alignItems: 'center' }}>
                    {params.value}
                </div>
            )
        },
        {
            id: 'resolved', numeric: true, disablePadding: false, label: t('commentcodesforISR.resolved', { ns: 'financialAidHeadcells' }),
            renderCell: (params) => <Checkbox checked={params.value === true || params.value === 'Y'} disabled disableRipple style={{ color: "rgba(0, 0, 0, 0.26)", padding: 0, backgroundColor: 'transparent' }} />
        },
        { id: 'note', numeric: true, disablePadding: false, label: t('commentcodesforISR.note', { ns: 'financialAidHeadcells' }) },
        { id: 'updateUserID', numeric: true, disablePadding: false, label: t('commentcodesforISR.updateUserID', { ns: 'financialAidHeadcells' }) },
        { id: 'uPdateTime', numeric: true, disablePadding: false, label: t('commentcodesforISR.uPdateTime', { ns: 'financialAidHeadcells' }),
            renderCell: (params) => (params.value ? formatTime(params.value) : '')
         },
    ], [t])
    const formik = useFormik({
        initialValues: initialValues,
        enableReinitialize: true,
        onSubmit: (values) => {

        },
    });
    const classes = useStyles();
    const [showAddData, setShowAddData] = useState(false);
    const [isLoading1, setIsLoading1] = useState(false);
    const [isLoading2, setIsLoading2] = useState(false);
    
    const onClose = (value) => {
        getGridOneData()
        if (selectedRow1) {
            handleISIRRowSelected(selectedRow1);
        }
        addDatas(false);
        setShowAddData(value);
        setShowAddIsirdetails(false);
        setShowCustomAddIsirdetails(false);
        setShowISIRFullReport(false);
        setShowUpdateISIRCommentCodesdetails(false);
        ElementsDataGridPro.resetTable("customISIRRec")
        document.getElementsByTagName("html")[0].classList.remove("popup-Page");
    };

    const getISIRRowClassName = (params) => {
    if (params.row.activeFlag === true || params.row.activeFlag === 'Y') {
      return 'course-blue';
    }
    return '';
  };

    const getGridOneData = async () => {
        setIsLoading1(true)
        try {
            var results = await getApi(`${isir_financial_grid_new}/${formik?.values?.filtertoPackage}/${selectedSelected.studentUID}`);
            setIsLoading1(false);
            setTableRow(results.data.data);
        }
        catch (err) {
            console.error(err);
            setIsLoading1(false);
        }
    }

    useEffect(() => {
        getApi(`${isir_select_items}/${selectedSelected.studentUID}/${selectedStatusRow.academicYearUID}`).then(resp => {
            resp.data.data.filterToPackageList.push({
                "uniqueId": -1,
                "displayText": "All",
                "isSelected": false
            },)
            setDropdown(resp.data.data)
        })
    }, [])

    useEffect(() => {
        setSelectedRow1('')
        setFullReportSelectedRow('')
        setResetGrid(prev => prev + 1)
        setTableRow2([])
        setSelectedCommentRows([])
        setResetGrid2(prev => prev + 1)
        getGridOneData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formik?.values?.filtertoPackage])

    const handleISIRRowSelected = async (row) => {
        setSelectedRow1(row)
        let fullReportRow = getFullReport(row)
        setFullReportSelectedRow(fullReportRow)
        setIsLoading2(true)
        setSelectedCommentRows([])
        setResetGrid2(prev => prev + 1)
        
        try {
            const comments = await getApi(`${isir_financial_grid_2_3}/${row.financialISIRID}/${selectedSelected.studentUID}/true`);
            setIsLoading2(false);
            setTableRow2(comments.data.data.commentsCodesJSONList);
        }
        catch (err) {
            console.error(err);
            setIsLoading2(false);
        }
    }

    const getFullReport = (row) => {
        let fullReport = {}
        for (let [key, value] of Object.entries(row)) {
            let item = financialISIR.find(o => o.id.toLowerCase().trim() === key.toLowerCase().trim());
            item == null ? fullReport[key] = value : fullReport[item.label] = value
        }
        return fullReport
    }

    const handleFinancialISIRDeleteClicked = (row) => {
        deleteApi(`${isir_financial}/${selectedRow1.financialISIRID}/true`).then(resp => {
            if (resp.data.data) {
                toastMessage(t('popupMessages.successIcon'), t('popupMessages.success'), t('popupMessages.successfullyDeleted'));
                getGridOneData()
                setSelectedRow1('')
                setFullReportSelectedRow('')
                setResetGrid(prev => prev + 1)
            }
        })
    };

    const setResolved = async () => {
        const target = selectedCommentRows.length > 0 ? selectedCommentRows : tableRow2;

        if (target.length === 0) {
            setShowPopup(true);
            return;
          }

        const payload = {
            IDs: target.map(el => el.id),
            isNewTable: true
        };
        
        await postApi(isir_set_comment_resolved, payload);
        toastMessage(t('popupMessages.successIcon'), t('popupMessages.success'), t('popupMessages.successfullySaved'));
        handleISIRRowSelected(selectedRow1);
    }

    const onFullDetailsClick = () => {
        setShowAddData(true);
        setShowAddIsirdetails(false)
        setShowCustomAddIsirdetails(false)
        setShowUpdateISIRCommentCodesdetails(false)
        addDatas(true)
        setShowISIRFullReport(true)
    }

    const onSetISIRActiveClick = () => {
       
        let payload = {
            id : selectedRow1.financialISIRID
        }

        postApi(ISIR_set_Active, payload).then(() => {
            toastMessage(t('popupMessages.successIcon'), t('popupMessages.success'), t('popupMessages.setActive'));
            getGridOneData();
        }).catch((e) => {
            console.log(e);
        })

    }

    const onToggleLockISIR = () => {
       
        let payload = {
            id : selectedRow1.financialISIRID
        }

        postApi(ISIR_Toggle_Lock, payload).then(() => {
            toastMessage(t('popupMessages.successIcon'), t('popupMessages.success'), t('popupMessages.toggleLockISIR'));
            getGridOneData();
        }).catch((e) => {
            console.log(e);
        })

    }

    // Role based access control redux
    const { access } = useSelector(updateAccessSelector)
    const { nestedParentLevel } = access;

    const [statusAccess, setStatusAccess] = useState({
        maintenance: 2,
    })

    useEffect(() => {
        let finStatusAccess = nestedParentLevel.filter((v, i) =>
            v.menuItemName.trim() === maintenance && v.moduleorder === 4
        )

        setStatusAccess({
            ...statusAccess,
            maintenance: (finStatusAccess.length > 0) ? finStatusAccess[0].menuAccess : 2,
        })

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [access])

    const [accessFlag, setAccessFlag] = useState(false)
    useEffect(() => {
        (statusAccess.maintenance !== 2) ? setAccessFlag(true) : setAccessFlag(false)
    }, [statusAccess])
    //RBA Ends here
    return (
        <>
            <GenericModal
                open={showPopup}
                title={"Please select a row to resolve"}
                onClose={setShowPopup}
            />
             <GenericModal title={msg} open={popup} onClose={setPopup} buttonText='Ok' id='commentPopup' />
            {!showAddData ?
                <>
                    <form onSubmit={formik.handleSubmit} className={classes.root}>
                        <Card>
                            <CardContent className={"headerTitle"}>
                            <p
                                style={{MarginTop: "5.5px", visibility: selectedRow1.pellEligibilityFlag == "Y" ? "Visible" : "hidden", border: "3px solid green", margin: "auto", width: "30%", "text-align": "center" }}
                            >Pell Eligible</p>
                            <ButtonGroup  groupedHorizontal="true" style={{ marginTop: "5.5px", float: "right"}} >
                            <ButtonWrapper className="ButtonDistribute">

                                <Button
                                        color="primary"
                                        variant="contained"
                                        size="large"
                                        type="button"
                                        onClick={onSetISIRActiveClick}
                                        disabled={selectedRow1 && !accessFlag ? false : true}
                                    >
                                        {t("commonLabel.setISIRActive", { ns: "financialAid" })}

                                </Button>
                                </ButtonWrapper>
                                <ButtonWrapper className="ButtonDistribute">
                                <Button
                                    color="primary"
                                    variant="contained"
                                    size="large"
                                    type="button"
                                    onClick={onToggleLockISIR}
                                    disabled={selectedRow1 && !accessFlag ? false : true}
                                   
                                >
                                    {t("commonLabel.toggleLockISIR", { ns: "financialAid" })}

                                </Button>
                                </ButtonWrapper>
                                <ButtonWrapper className="ButtonDistribute">

                                    <Button
                                        color="primary"
                                        variant="contained"
                                        size="large"
                                        type="button"
                                        onClick={onFullDetailsClick}
                                        disabled={selectedRow1 ? false : true}
                                    >
                                        {t("commonLabel.fullDetails", { ns: "financialAid" })}

                                    </Button>
                                  
                                </ButtonWrapper>
                                </ButtonGroup>
                                <FormGroup>
                                    <SelectInput
                                        label={t("commonLabel.filtertoPackage", { ns: "financialAid" })}
                                        labelId={"filtertoPackage"}
                                        formikValue={formik.values.filtertoPackage}
                                        formikChange={formik.handleChange}
                                        dropdownData={{ key: "displayText", value: 'uniqueId', optionLists: dropdown.filterToPackageList }}
                                    />
                                </FormGroup>
                               
                                <ElementsDataGridPro
                                    isLoading={isLoading1}
                                    trackingLabel={"batchesBilling"}
                                    headCells={financialISIR}
                                    rows={tableRow}
                                    pagination={true}
                                    selectionModelChanged={(rows) => {
                                        if (rows?.length > 0) {
                                            handleISIRRowSelected(rows[0]);
                                        } else {
                                            setTableRow2([]);
                                            setSelectedRow1('');
                                            setFullReportSelectedRow('');
                                            setSelectedCommentRows([]);
                                            setResetGrid2(prev => prev + 1);
                                        }
                                    }}
                                    onDelete={handleFinancialISIRDeleteClicked}
                                    addEditAccess={!accessFlag}
                                    resetGridSelection={resetGrid}
                                    getRowClassName={getISIRRowClassName}
                                />
                                 
                            </CardContent>
                        </Card>
                        <Splitter />
                        <Card>
                            <CardContent className={"headerTitle"}>
                                <FormGroup>
                                    <HeaderTitle variant={'subHeading'}
                                        headerTitle={t("commonLabel.commentCodesforselectedISIRrecord", { ns: "financialAid" })}
                                        addData={() => {
                                            setShowAddData(false);
                                            addDatas(false)
                                            setShowCustomAddIsirdetails(false)
                                            setShowAddIsirdetails(false)
                                            setShowUpdateISIRCommentCodesdetails(false)

                                            setResolved()
                                        }}
                                        buttonText={t("buttonLabel.setAlltoResolved", { ns: "financialAid" })}
                                        disableButton={(statusAccess.maintenance !== 2) ? true : false}
                                    />
                                </FormGroup>
                                <ElementsDataGridPro
                                    isLoading={isLoading2}
                                    trackingLabel={"commentCodes"}
                                    headCells={commentcodesforISR}
                                    rows={tableRow2}
                                    pagination={true}
                                    checkboxSelection={true}
                                    multiSelect={false}
                                    selectionModelChanged={(rows) => setSelectedCommentRows(rows)}
                                    onEdit={(row) => { 
                                        setSelectedCommentRows([row]);
                                        setShowAddData(true);
                                        addDatas(true);
                                        setShowUpdateISIRCommentCodesdetails(true);
                                    }}
                                    addEditAccess={!accessFlag}
                                    resetGridSelection={resetGrid2}
                                />
                                
                            </CardContent>
                        </Card>
                        <Splitter />
                    </form>
                </> : (showUpdateISIRCommentCodesdetails) ? <UpdateISIRCommentCodesdetails accessFlag={accessFlag} selectedRow1ISIR={selectedRow1} selectedCommentRows={selectedCommentRows}  onClose={onClose}  />
                : (showAddIsirdetails) ? <AddISIRSAIDetails accessFlag={accessFlag} selectedRow1={selectedRow1} dropdown={dropdown} addDatas={addDatas} onClose={onClose} FinancialStatusUID={formik.values.filtertoPackage} />
                    : (showAddCustomIsirdetails) ? <AddCustomISRRecord accessFlag={accessFlag} dropdown={dropdown} addDatas={addDatas} onClose={onClose} />
                        : (showISIRFullReport) && <ShowISIRReport selectedRow={fullReportSelectedRow} financialISIR={financialISIR} onClose={onClose} />

            }
        </>
    );
};
export default Isir; 